import { Loader } from '@deque/cauldron-react';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';

import type { ProductSwitcherItem } from '@deque/ui-navbar';
import { getProductUrl } from '../constants';
import {
  useTrialActivate,
  type UseTrialActivateProps
} from '../hooks/useTrialActivate';
import { AxeProductVisionWebinarBanner } from './AxeProductVisionWebinarBanner';
import Header from './Header';
import MainLayout from './MainLayout';

type AxeProductTrialProps = UseTrialActivateProps;

const AxeProductTrial = ({ productSlug }: AxeProductTrialProps) => {
  const { t } = useTranslation();
  const { loading, error } = useTrialActivate({ productSlug });

  const loaderRef = useRef<HTMLDivElement>(null);

  const redirectURL = (!error && getProductUrl(productSlug, 'welcome')) || '/';

  const currentProduct: ProductSwitcherItem = {
    name: 'Axe Account',
    url: '/',
    slug: 'axe-account'
  };

  useEffect(() => {
    loaderRef.current?.focus();
  }, [loaderRef.current]);

  return (
    <MainLayout
      header={<Header currentProduct={currentProduct} />}
      shouldShowFooter={false}
      promotionalBanner={<AxeProductVisionWebinarBanner />}
    >
      {loading ? (
        <Loader
          label={t('Loading...')}
          tabIndex={-1}
          ref={loaderRef}
          data-testid="no-enterprise-loader"
        />
      ) : (
        <Redirect to={redirectURL} />
      )}
    </MainLayout>
  );
};

export default AxeProductTrial;
